<app-static-pages-header [title]="'Absichtserklärung'"></app-static-pages-header>
<div class="container data-policy">
  <div class="row justify-content-md-center">
    <div class="col-md-8 app__justify-text">
      <h2 class="main__title">Absichtserklärung betreffend Verwendung von fan.at als Vereinsplattform</h2>

      <p>Die Plattform fan.at bietet Vereinen einen Kanal, um gleichzeitig alle Vereinsinfos – mit der Möglichkeit zur Integration der Vereinssponsoren – in <b>App, Web und Social Media</b> zu kommunizieren. Ziel ist es einerseits, den Aufwand für Vereine zu minimieren und anderseits, die Fancommunity des Vereins zu maximieren.</p>

      <p>Als Verein beabsichtigt man, die Plattform fan.at ab deren Veröffentlichung als Vereinsplattform zu verwenden. Ab Veröffentlichung der fan.at Plattform wird der Verein für diese freigeschaltet und erhält folgende Zugänge:</p>

      <h3>Eigene Teamverwaltung</h3>

      <p>Mit diesem Zugang können folgende Inhalte eingegeben werden:</p>
      <ul>
        <li><b>News</b></li>
        <li><b>Spiele</b></li>
        <li><b>Liveticker</b></li>
        <li><b>Kader</b></li>
        <li><b>Sponsoren</b></li>
        <li><b>Diverse Informationen</b> (Logo, Teamfarbe, Stadion, Social Media, Kontakt, Verwaltung von Reporter (Redakteuren) etc.)</li>
        <li><b>Option zur parallelen Veröffentlichung diverser Beiträge</b> (News, Liveticker) auf anderen Plattformen (wie z.B. Facebook)</li>
      </ul>

      <h3>Eigene App- und Webseite</h3>
      <p>Mit diesem Zugang können folgende Inhalte eingegeben werden:</p>
      <ul>
        <li><b>News</b></li>
        <li><b>Spiele</b></li>
        <li><b>Tabelle</b></li>
        <li><b>Kader</b></li>
        <li><b>Sponsoren</b></li>
        <li><b>Diverse Informationen</b> (Logo, Stadion, Social Media, Kontakt etc.)</li>
        <li><b>Diverse App-Benachrichtigungen</b>, um die Follower der Appseite direkt zu erreichen</li>
      </ul>

      <p>Im Rahmen der Nutzung der fan.at Plattform wird der Verein sicherstellen, dass es zumindest einen Teamreporter gibt, der in der Teamverwaltung regelmäßig Inhalte (wie z.B. News, Liveticker etc.) erstellt.</p>

      <p>Mit Abschluss des Vertrages zwischen dem Verein und fan.at (= SFA Sport GmbH) zur Nutzung der Plattform werde ich fan.at berechtigen, diese Person(en) zu kontaktieren und im Detail darüber einzuschulen, wie sie die fan.at Plattform für den Verein am Besten verwenden können.</p>

      <p>Zudem werde ich im Vereinsnamen die fan.at Plattform (also die SFA Sport GmbH sowie die mit ihr verbundenen Unternehmen wie insbesondere krone.at/Krone Multimedia GmbH & Co KG) berechtigen, diese Inhalte auf deren Plattform(en) für diverse (redaktionelle) Beiträge zu verwenden.</p>

      <p>Zur Klarstellung wird hiermit festgehalten, dass die gegenständliche Absichtserklärung unverbindlich ist und aus dieser daher keine fan.at Forderungen gegenüber dem Verein resultieren (etwa auf Vertragsabschluss oder Zahlungsansprüche).</p>
    </div>
  </div>
</div>

